import React from "react";
import axios from 'axios';

import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";

import './dashboardHeader.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import OrderDetails from "../MoneyTransferComponent/OrderDetails";
import TransferDetails from "../MoneyTransferComponent/TransferDetails";
import SubTransactionDetails from "../MoneyTransferComponent/SubTransactionDetails";

import { store } from "../../redux/store";
import moment from "moment";
import { selectedBeneList, setTxnHistoryElementNo, setTxnHistoryResponse } from "../../redux/misc-data/misc-data.action";
import { setAddBenefisciaryRequest, setTxnHistoryPaginationResponse, setSendersListDetails, selectedSender, resetMiscData, setBeneMoneyTransfer, setGraphResponse } from './../../redux/misc-data/misc-data.action';
import SubTransactionTxn from "../MoneyTransferComponent/SubTransactionTxn";
import BankLogo from "../../assests/images/bank-logo.png";
import FinxPayLogo from "../../assests/images/finxpay.png";
import Avatar from 'react-avatar';
import TransactionGraph from "./TransactionGraph";
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import ContentLoader from 'react-content-loader';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";

const httpClient = axios.create();

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: '',

            showModal: false,
            beneName: '',
            beneAccount: '',
            bankName: '',
            beneifscCode: '',
            senderName: '',
            transferredAmount: '',
            surcharge: '',
            totalAmount: '',

            orderId: '',
            createdOn: '',
            paymentStatus: '',
            errorMessage: '',
            showSenderVisible: false,
            contentLoading: false,
            txnSubOrder: '',
            senderSearchLoading: ''
        }
    }

    printdiv = (event) => {
        event.preventDefault();
        var divContents = document.getElementById("print").innerHTML;
        var a = window.open('', '', 'height=500, width=500');
        a.document.write('<html>');
        a.document.write('<body>');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }



    viewSendersList = (event, mobileNo) => {

        event.preventDefault();
        this.setState({
            showSenderVisible: false
        })
        store.dispatch(setSendersListDetails(''));

        var allsenderuRL = '/api/v1/dmt/customer/details/' + mobileNo;
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(allsenderuRL, { headers }
        ).then((response) => {
            console.log('selected sender response' + JSON.stringify(response.data));
            console.log(response.data.response.msg);
            if (response.data.response.msg == 'SUCCESS') {

                store.dispatch(selectedSender(response.data));
                store.dispatch(selectedBeneList(response.data.customer.beneficiaries));
                var gotosenderpage = document.getElementById('gotosenderpage');
                gotosenderpage.click();

            } else {

            }
        }).catch(error => {

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }


        });
    }


    moDalPrint = (event, txn) => {
        event.preventDefault();

        this.setState({
            showModal: true,
            paymentStatus: txn.status != null ? txn.status : 'Unknown Status',
            beneName: txn.beneficiary.name != null ? txn.beneficiary.name : 'Unknown Benefisciary',
            beneAccount: txn.beneficiary.account != null && txn.beneficiary.account.accNum,
            bankName: txn.beneficiary.account != null && txn.beneficiary.account.bank,
            beneifscCode: txn.beneficiary.account != null && txn.beneficiary.account.ifsc,
            senderName: txn.customer.name != null ? txn.customer.name : 'Unknown Sender',
            transferredAmount: txn.transaction != null && txn.transaction.amount,
            surcharge: txn.origTxn != null ? parseFloat(txn.origTxn.surcharge).toFixed(2) : '0.00',
            totalAmount: parseFloat(txn.origTxn != null ? parseFloat(txn.origTxn.amount).toFixed() : '0.00') +
                parseFloat(txn.origTxn != null ? txn.origTxn.surcharge : '0.00'),
            orderId: txn.id != null ? txn.id : 'Unlnown Id',
            createdOn: moment(txn.createdOn).format('DD-MM-YYYY hh:mm:ss'),
            txnSubOrder: txn.subOrders != null ? txn.subOrders : '',

        })
    }




    componentDidMount() {

        this.loadRetailerBalance();


        store.dispatch(setTxnHistoryResponse(''));
        store.dispatch(setTxnHistoryElementNo(0));
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        var d = new Date();
        d.setDate(d.getDate() - 2);
        var fromDate = d.toISOString().slice(0, 10);
        var d1 = new Date();
        d1.setDate(d1.getDate() + 1);
        var toDate = d1.toISOString().slice(0, 10);
        console.log('to date..' + toDate);
        console.log('start date' + fromDate);


        var url = '/api/v1/dmt/order/history' + '/' + this.props.agentInfo.id + '/' + fromDate + '/' + toDate;

        this.setState({
            contentLoading: true
        })

        httpClient.get(url, { headers }
        ).then((response) => {

            this.setState({
                contentLoading: false
            })

            // var orderBycreatedTime = response.data.list;
            // orderBycreatedTime.sort(({ time: a }, { time: b }) => a > b ? 1 : a < b ? -1 : 0).reverse();
            // response.data.list = orderBycreatedTime;

            if (response.data.response.msg == 'SUCCESS') {
                console.log('transaction history successresponse....' + response.data.list);

                store.dispatch(setTxnHistoryResponse(response.data.list));
                store.dispatch(setTxnHistoryElementNo(response.data.totalElements));

            } else {

                console.log('transaction history failure response....' + response.data);
                this.errorMessageCall(response.data.response.displayMsg);

            }
        }).catch(error => {

            this.setState({
                contentLoading: false
            })
            this.errorMessageCall('Something went wrong');

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }
        });
    }
    componentWillUnmount() {
    }
    loadRetailerBalance = () => {

        var url = '/api/v1/account/balance/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(url + this.props.agentInfo.id, { headers }
        ).then((response) => {
            //   alert(JSON.stringify(response.data))
        }).catch(error => {


            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            }


        });
    }

    errorMessageCall = (error) => {
        this.setState({
            errorMessage: error
        })
    }




    moneyTransfer = (event, txn) => {


        event.preventDefault();
        this.setState({
            showSenderVisible: false
        })
        store.dispatch(setSendersListDetails(''));

        var senderDetailsUrl = '/api/v1/dmt/customer/details/' + txn.customer.mobile;
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(senderDetailsUrl, { headers }
        ).then((response) => {
            console.log('selected sender response' + JSON.stringify(response.data));
            console.log(response.data.response.msg);
            if (response.data.response.msg == 'SUCCESS') {

                store.dispatch(selectedSender(response.data));
                store.dispatch(selectedBeneList(response.data.customer.beneficiaries));

                var benefc = {
                    name: txn.beneficiary.name,
                    bankName: txn.beneficiary.account.bank,
                    accountNumber: txn.beneficiary.account.accNum,
                    ifscCode: txn.beneficiary.account.ifsc,
                    beneId: txn.beneficiary.id,
                    beneMobile: txn.beneficiary.account.mobile
                }

                store.dispatch(setBeneMoneyTransfer(benefc));

                var gotomoneytransfer = document.getElementById('gotomoneytransfer');
                gotomoneytransfer.click();
            } else {
                // alert(response.data.response.msg);
            }
        }).catch(error => {
            this.errorMessageCall(error.message);
            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {

            }


        });
    }


    searchSender = (event) => {
        console.log(event.target.value);
        this.setState({
            searchInput: event.target.value
        })

        this.searchSenderDetails(event.target.value);
    }

    searchSenderDetails(searchno) {
        store.dispatch(setSendersListDetails(''));
        console.log('searchInput...' + searchno);
        var searchSenderUrl = "/api/v1/dmt/customer/search/" + searchno;



        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        if (searchno.length >= 4) {

            this.setState({
                senderSearchLoading: 'inprogress'
            })
            httpClient.get(searchSenderUrl, { headers }
            ).then((response) => {
                console.log('search response' + JSON.stringify(response.data));
                if (response.data.response.msg == 'SUCCESS'
                    && response.data.searchStr == searchno) {

                    this.setState({
                        showSenderVisible: true,
                        senderSearchLoading: 'completed'
                    })

                    store.dispatch(setSendersListDetails(response.data));


                } else {
                    this.setState({
                        showSenderVisible: true,
                        senderSearchLoading: 'completed'
                    })
                }
            }).catch(error => {
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else {

                }

                this.setState({
                    senderSearchLoading: 'completed'
                })

                console.log('search sender error:' + error);

            });

        } else {
            this.setState({
                showSenderVisible: false
            })
        }
    }



    render() {
        console.log('txnhistory', JSON.stringify(this.props.txnHistoryResponse));
        var recentTxnLoop = ['test', 'test', 'test', 'test', 'test'];
        return (
            <div>

                <HeaderCommon />
                <Menu />

                <div class="main">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 col-lg-5 col-xl-4">
                                <div class="topcard">
                                    <div class="top-box">
                                        <Link to='/sender'>
                                            <button id="gotosenderpage" hidden={true}></button>
                                        </Link>
                                        <Link to='/add-sender'>
                                            <button id="addSenderSuccess" class="addbtn">Add Sender</button>
                                        </Link>
                                        <Link to='/money-transfer'>
                                            <button id='gotomoneytransfer' hidden={true}></button>
                                        </Link>
                                        <i></i>
                                        <h5>Money Transfer</h5>
                                    </div>
                                    <div class="search-sender">

                                        <input type="number" placeholder="Search sender by mobile..." id="searchsender"
                                            onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                            onKeyUp={this.searchSender} />
                                        <Link to="/senders-list">
                                            <button class="lbbtn">View All</button>
                                        </Link>

                                        {this.state.showSenderVisible == true &&
                                            <div class="senderlist" id="showsender">

                                                {this.props.senderListDetails != '' ?
                                                    this.props.senderListDetails.response.msg == 'SUCCESS' &&

                                                    this.props.senderListDetails.list.map(customer => (
                                                        <div class="sender" onClick={e => this.viewSendersList(e, customer.mobile)}>
                                                            <Avatar name={customer.name} round={true} size="40" alt="" />
                                                            <h4>{customer.name}</h4>
                                                            <p>{customer.mobile}</p>
                                                        </div>
                                                    )) :


                                                    this.state.senderSearchLoading == 'completed' ?
                                                        'Sender not found' : 'Searching sender....'
                                                    // <div class="addsender">
                                                    //     Sender not found
                                                    // </div> :
                                                    // <div class="addsender">
                                                    //     Searching sender....
                                                    // </div>


                                                }
                                            </div>
                                        }
                                    </div>


                                    <div class="lasttnsfr">
                                        <h3>Recent Money Transfer</h3>

                                        {this.state.errorMessage == '' &&
                                            this.props.txnHistoryResponse.length > 0 &&
                                            this.props.txnHistoryResponse.slice(0, 2).map((txn, index) => (
                                                txn.origTxn.amount!='1.00' &&
                                                txn.origTxn.amount!='1' &&
                                                <div class="recbene">
                                                    {txn.origTxn.amount != '1.00' &&
                                                        txn.origTxn.amount != '1' &&
                                                        <button type="button" class="lbbtn" onClick={e => this.moneyTransfer(e, txn)}>Transfer</button>
                                                    }
                                                    {(txn.beneficiary != null && txn.beneficiary.account != null && txn.beneficiary.account.bank &&
                                                        this.props.bankLogoListTxt.includes(txn.beneficiary.account.bank.split(' ').join("-") + ".PNG")) ?
                                                        <img src={'/bank_images/' + txn.beneficiary.account.bank.toLowerCase().split(' ').join("-") + ".png"} alt="bank" /> :
                                                        <img src={BankLogo} alt="bank" />
                                                    }
                                                    <h4 class="verify"
                                                    >{(txn.beneficiary != null && txn.beneficiary.name != null) ? txn.beneficiary.name : 'NA'}
                                                    </h4>
                                                    <p class="text-truncate">  {(txn.beneficiary != null && txn.beneficiary.account != null &&
                                                        txn.beneficiary.account.accNum != null) ? txn.beneficiary.account.accNum : 'NA'} -
                                                        {(txn.beneficiary != null && txn.beneficiary.account != null && txn.beneficiary.account.bank != null) ? " " + txn.beneficiary.account.bank : "NA"}</p>
                                                </div>
                                            ))
                                        }

                                        {this.state.errorMessage == '' &&
                                            this.state.contentLoading == true &&
                                            <div class="recbene">
                                                <ContentLoader
                                                    width={350}

                                                    height={50}
                                                    speed={1}
                                                    backgroundColor="#f3f3f3"
                                                    foregroundColor="#ecebeb"
                                                    viewBox="0 0 350 50"
                                                ><rect x="48" y="8" rx="3" ry="3" width="100" height="6" />
                                                    <rect x="48" y="26" rx="3" ry="3" width="40" height="6" />
                                                    <circle cx="20" cy="20" r="20" />
                                                </ContentLoader>
                                            </div>
                                        }
                                        {
                                            this.state.errorMessage == '' &&
                                            this.state.contentLoading == false &&
                                            this.props.txnHistoryResponse.length == 0 &&

                                            <div>
                                                No Recent records found
                                            </div>
                                        }
                                        {this.state.errorMessage != '' &&
                                            <div class='valid-error'>
                                                {this.state.errorMessage}
                                            </div>}

                                    </div>
                                </div>

                                <TransactionGraph />

                            </div>

                            <div class="col-12 col-lg-7 col-xl-8">
                                <div class="card-b" id="rightdiv">
                                    <div id="recenttxn">
                                        <div class="head">
                                            <h3>Recent Transactions</h3>
                                            <Link to="/transaction-history">
                                                <button class="addbtn">View All</button>
                                            </Link>
                                        </div>

                                        <div class="txn-list" id="recntxn">
                                            {this.state.errorMessage == '' &&
                                                this.props.txnHistoryResponse.length > 0 &&
                                                this.props.txnHistoryResponse.slice(0, 6).map((txn, index) => (
                                                    <div class="txn-item">
                                                        <div class="txn-head" id={"txnhead" + index}>
                                                            <div class="collapsed" data-bs-toggle="collapse" data-bs-target={"#txn" + index}
                                                                aria-expanded="false" aria-controls={"txn" + index}>
                                                                <div class={txn.status == 'SUCCESS' ? "txncard grbg" :
                                                                    txn.status == 'PROCESSING' ? "txncard ylbg" :
                                                                        txn.status == 'FAILED' ? "txncard rdbg" : "txncard ylbg"}>
                                                                    <div class="row">
                                                                        <div class="col-12 col-md-4">
                                                                            <div class="txntype">
                                                                                {(txn.beneficiary != null && txn.beneficiary.account != null && txn.beneficiary.account.bank &&
                                                                                    this.props.bankLogoListTxt.includes(txn.beneficiary.account.bank.split(' ').join("-") + ".PNG")) ?
                                                                                    <img src={'/bank_images/' + txn.beneficiary.account.bank.toLowerCase().split(' ').join("-") + ".png"} alt="bank" /> :
                                                                                    <img src={BankLogo} alt="bank" />
                                                                                }
                                                                                <h5>Money Transfer</h5>
                                                                                <p>{(txn.beneficiary != null && txn.beneficiary.name != null) ?
                                                                                    txn.beneficiary.name : 'Unknown'}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-7 col-md-6">
                                                                            <div class="txnid">
                                                                                <h6>#{txn.id.toUpperCase()}</h6>
                                                                                <p>{moment(txn.createdOn).format('DD-MM-YYYY hh:mm:ss')}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-5 col-md-2">
                                                                            <div class="txnamt">
                                                                                <h4>₹ {txn.transaction != null && txn.transaction.amount}</h4>
                                                                                {txn.status == 'SUCCESS' &&
                                                                                    <p class="success">{txn.status.substring(0, 1).toUpperCase() +
                                                                                        txn.status.substring(1, txn.status.length).toLowerCase()}</p>
                                                                                }
                                                                                {txn.status == 'PROCESSING' &&
                                                                                    <p class="pending">{txn.status.substring(0, 1).toUpperCase() +
                                                                                        txn.status.substring(1, txn.status.length).toLowerCase()}</p>
                                                                                }

                                                                                {txn.status == 'FAILED' &&
                                                                                    <p class="failed">{txn.status.substring(0, 1).toUpperCase() +
                                                                                        txn.status.substring(1, txn.status.length).toLowerCase()}</p>
                                                                                }

                                                                                {(txn.status == '' || txn.status == undefined || txn.status == null) &&
                                                                                    <p class="pending">{txn.status}</p>
                                                                                }

                                                                                {txn.origTxn == null &&
                                                                                    <p class="failed">Failed</p>
                                                                                }


                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div id={"txn" + index} class="accordion-collapse collapse"
                                                                aria-labelledby={"txnhead" + index} data-bs-parent="#recntxn">
                                                                <div class="txn-details">
                                                                    <div class="row">
                                                                        <div class="col-6 col-md-4">
                                                                            <div class="txnid">
                                                                                <h6>Account Nubmer</h6>
                                                                                <p>{(txn.beneficiary != null && txn.beneficiary.account != null &&
                                                                                    txn.beneficiary.account.accNum != null) ? txn.beneficiary.account.accNum : 'NA'}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-6 col-md-4">
                                                                            <div class="txnid srtxt">
                                                                                <h6>IFSC Code</h6>
                                                                                <p>{(txn.beneficiary != null && txn.beneficiary.account != null
                                                                                    && txn.beneficiary.account.ifsc != null) ? txn.beneficiary.account.ifsc : 'NA'}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-12 col-md-4">
                                                                            <div class="txnid text-md-end">
                                                                                <h6>Sender Details</h6>
                                                                                <p>{(txn.customer != null && txn.customer.name != null) ? txn.customer.name : 'Unknown User'} -
                                                                                    {(txn.customer != null && txn.customer.mobile != null) ? txn.customer.mobile : 'Unknown Mobile'}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {(txn.subOrders != null && txn.subOrders != '' && txn.subOrders != undefined) &&
                                                                    <div class="ordertxn">
                                                                        <SubTransactionTxn response={txn.subOrders}
                                                                            createdOn={txn.createdOn} />
                                                                    </div>

                                                                }

                                                                <div class="ordertxn">
                                                                    <div class="row">
                                                                        {(txn.origTxn != null && txn.origTxn != '' && txn.origTxn != undefined) ?
                                                                            <OrderDetails amount={txn.origTxn.amount}
                                                                                surcharge={txn.origTxn.surcharge}
                                                                                totalAmount={parseFloat(txn.origTxn.amount) +
                                                                                    parseFloat(txn.origTxn.surcharge)}
                                                                                res={txn.amount} />
                                                                            :
                                                                            <OrderDetails amount={0}
                                                                                surcharge={0}
                                                                                totalAmount={0}
                                                                                res={txn.amount} />
                                                                        }

                                                                        {(txn.finalTxn != null && txn.finalTxn != '' && txn.finalTxn != undefined) ?
                                                                            <TransferDetails amount={txn.finalTxn.amount}
                                                                                surcharge={txn.finalTxn.surcharge}
                                                                                totalAmount={parseFloat(txn.finalTxn.amount) +
                                                                                    parseFloat(txn.finalTxn.surcharge)}
                                                                                res={txn.amount} />
                                                                            :
                                                                            <TransferDetails amount={0}
                                                                                surcharge={0}
                                                                                totalAmount={0}
                                                                                res={txn.amount} />
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div class="txn-btn">

                                                                    {txn.origTxn.amount != '1.00' &&

                                                                        <button type="button" class="retry" onClick={e => this.moneyTransfer(e, txn)}>Repeat</button>
                                                                    }

                                                                    {txn.origTxn != null &&
                                                                        txn.origTxn.amount != '1.00' &&
                                                                        txn.origTxn.amount != '1' &&
                                                                        <button type="button" class="print"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#print"
                                                                            onClick={e => this.moDalPrint(e, txn)}>Print</button>
                                                                    }
                                                                    {/* <button type="button" class="help" data-toggle="tooltip" title="Help"></button> */}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }

                                            {this.state.errorMessage == '' &&
                                                this.state.contentLoading == false &&
                                                this.props.txnHistoryResponse.length == 0 &&
                                                <div>
                                                    No Recent records found
                                                </div>

                                            }



                                            {this.state.errorMessage == '' &&
                                                this.state.contentLoading == true &&
                                                recentTxnLoop.map((rctn, index) => (
                                                    <div class="txn-item">
                                                        <div class="txncard">
                                                            <ContentLoader
                                                                width={350}

                                                                height={50}
                                                                speed={1}
                                                                backgroundColor="#f3f3f3"
                                                                foregroundColor="#ecebeb"
                                                                viewBox="0 0 350 50"
                                                            ><rect x="48" y="8" rx="3" ry="3" width="100" height="6" />
                                                                <rect x="48" y="26" rx="3" ry="3" width="40" height="6" />
                                                                <circle cx="20" cy="20" r="20" />
                                                            </ContentLoader>
                                                        </div>
                                                    </div>))
                                            }


                                            {this.state.errorMessage != '' &&
                                                <div class='valid-error'>
                                                    {this.state.errorMessage}
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <FooterComponet />

                <div class="modal fade" id="print" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header modhead">
                                <h5 class="modal-title">Money Transfer Reciept</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="printtable">
                                    <div class="printlogo">
                                        <img src={FinxPayLogo} alt="logo" />
                                    </div>
                                    <table class="table table-striped table-bordered" border="1" border-collapse>
                                        <tbody>
                                            <tr>
                                                <td>Payment Status:</td>
                                                <td><strong> {this.state.paymentStatus.substring(0, 1).toUpperCase() +
                                                    this.state.paymentStatus.substring(1, this.state.paymentStatus.length).toLowerCase()}
                                                </strong></td>
                                            </tr>
                                            <tr>
                                                <td>Benefisciary Name:</td>
                                                <td>{this.state.beneName}</td>
                                            </tr>
                                            <tr>
                                                <td>Benefisciary Account No:</td>
                                                <td>{this.state.beneAccount}</td>
                                            </tr>

                                            <tr>
                                                <td>Bank Name:</td>
                                                <td>{this.state.bankName}</td>
                                            </tr>

                                            <tr>
                                                <td>IFSC Code:</td>
                                                <td>{this.state.beneifscCode}</td>
                                            </tr>
                                            <tr>
                                                <td>Sender Name:</td>
                                                <td>{this.state.senderName}</td>
                                            </tr>

                                            <tr>
                                                <td>Transfer Amount:</td>
                                                <td>₹ {this.state.transferredAmount}</td>
                                            </tr>
                                            <tr>
                                                <td>Surcharge:</td>
                                                <td>₹ {this.state.surcharge}</td>
                                            </tr>


                                            <tr>
                                                <td>Total Amount:</td>
                                                <td>₹ {parseFloat(this.state.totalAmount).toFixed(2)}</td>
                                            </tr>

                                            <tr>
                                                <td>Order Id:</td>
                                                <td>{this.state.orderId}</td>
                                            </tr>

                                            <tr>
                                                <td>Date:</td>
                                                <td>{this.state.createdOn}</td>
                                            </tr>

                                        </tbody>
                                    </table>

                                    {this.state.txnSubOrder != '' &&

                                        <table class="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td colspan="3">Sub Transactions Details:</td>
                                                </tr>
                                                <tr class="table-secondary">
                                                    <td>Transactions ID</td>
                                                    <td>Amount</td>
                                                    <td>Status</td>
                                                    <td>Payment Ref.</td>
                                                </tr>

                                                {this.state.txnSubOrder.map(txRsp => (

                                                    <tr>
                                                        <td>{txRsp.id}</td>
                                                        <td>₹ {parseFloat(txRsp.txnDetails.amount).toFixed(2)}</td>
                                                        <td>{txRsp.status == 'INIT' ? 'Pending' : txRsp.status.substring(0, 1).toUpperCase() +
                                                            txRsp.status.substring(1, txRsp.status.length).toLowerCase()}</td>
                                                        <td>
                                                            {txRsp.paymentRefId}
                                                        </td>
                                                    </tr>
                                                ))
                                                }
                                            </tbody>
                                        </table>
                                    }


                                </div>
                            </div>
                            <div class="modal-footer mdftr">
                                <button type="button" class="btn dbbtn" data-bs-dismiss="modal" onClick={e => this.printdiv(e)}>Print</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        );

    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, txnHistoryResponse, agentInfo, token, clientRole, loginTime, senderListDetails,
            bankLogoListTxt, graphResponse, clientRequesterId, callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, txnHistoryResponse,
    agentInfo, token, clientRole, loginTime, senderListDetails, bankLogoListTxt,
    graphResponse, clientRequesterId, callBackUrl
});

export default connect(mapStateToProps, null)(Dashboard);
